import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Agencies } from 'app/models/agencies';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { S3Client, DeleteObjectCommand } from '@aws-sdk/client-s3';

import { SearchService } from 'app/services/search/search.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-promoteurs-monastir',
  templateUrl: './promoteurs-monastir.component.html',
  styleUrls: ['./promoteurs-monastir.component.scss']
})
export class PromoteursMonastirComponent implements OnInit {

  public agenciesMonastir: any
  public lengthBoutique:any
  public testArraySort: any
  responsiveOptions
  @ViewChild('agencyForm', { static: false })
  agencyForm: NgForm;
  p: Number = 1;
  agenciedData: Agencies;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isEditMode = false;
  public agencies:any
  closeResult = '';
  search_name1:any;
  public idAgency: any
  public Agency: any
  public search: string  = ''
  pageIndex:number = 0;
  pageSize:number = 50;
  lowValue:number = 0;
  highValue:number = 50; 
  lengthSociete=10;
  totalSociete : any;
  arrays: any[] = [];
  tempArray: any[] = [];
  newArray: any[] = []
  agencie: any;

  constructor(private agencieService: AgenciesService,
    private searchService: SearchService) { }

  ngOnInit(): void {
    this.getagencesMonastir();
  }
  getagencesMonastir() {
    this.agencieService.getAgencieMonastir().subscribe((data: any) => {
      this.agenciesMonastir = data;
      this.agencie=this.agenciesMonastir
      console.log("liste des agences en tunis", this.agenciesMonastir);
      // Filtrer les promoteurs de Tunis
      this.agencies = this.agenciesMonastir
      .sort((a: any, b: any) => {
        // Sort based on the existence of projets array
        if (a.projets.length === 0 && b.projets.length > 0) {
          return 1; // Move agencie with empty projets to the end
        } else if (a.projets.length > 0 && b.projets.length === 0) {
          return -1; // Move agencie with non-empty projets to the beginning
        } else {
          return 0;  
        }
      });
        
    });
  }



cancelEdit() {
  this.isEditMode = false;
  this.agencyForm.resetForm();
}

 

deleteAgencies(agencie, i) {
  const s3 = new S3Client({
    region: 'eu-west-3',
    credentials: {
  // accessKeyId: "0",
  //        secretAccessKey: "0",
        //accessKeyId: "0",
         //  secretAccessKey: "0",
          accessKeyId: "0",
           secretAccessKey: "0",
    },
  });

  Swal.fire({
    title: "Êtes-vous sûr(e) ?",
    text: "Vous ne pourrez pas revenir en arrière !",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Oui, supprimez-le."
  }).then((result) => {
    if (result.isConfirmed) {
      const logoUrl = agencie.logo_url;  
      const bucketName = logoUrl.split(".s3.")[0].split("//")[1];  
      const objectKey = logoUrl.split(".com/")[1];  

      const deleteParams = {
        Bucket: bucketName,
        Key: objectKey,
      };

      
      s3.send(new DeleteObjectCommand(deleteParams))
        .then(() => {
          console.log("Image deleted from S3 successfully");

          this.agencieService.deleteItem(agencie.id).subscribe((response: any) => {
            console.log(this.dataSource.data);

            Swal.fire({
              title: "Supprimé!",
              text: "Votre agence a été supprimée.",
              icon: "success"
            });

             setTimeout(() => {
              this.getagencesMonastir();
            }, 500);
          });
        })
        .catch((error) => {
          console.error("Error deleting image from S3:", error);
          Swal.fire({
            title: "Erreur!",
            text: "Échec de la suppression de l'image S3.",
            icon: "error"
          });
        });
    }
  });
}

public changePage(){
  this.lengthSociete=this.lengthSociete+10;
}
 performSearch() {
  this.agenciesMonastir = this.searchService.search(this.agenciesMonastir, this.search);
}
}